const isPage = (): boolean => {
  return (
    document.body.classList.contains("page") ||
    document.body.classList.contains("page-template-default") ||
    document.querySelector("main.page") !== null
  );
}

export default isPage;